module.exports = __webpack_public_path__ + "img/time.cd2f414d.svg";